import React, { Component } from "react";
import "./style.scss";

class Banner extends Component {
  render() {
    const {
      grid,
      children,
      className = "",
      style = {},
      px = "px-4",
    } = this.props;

    // remove px and pass in className
    //
    return (
      <li
        className={`bannerComp w-100 bg-primary rounded-pill position-sticky ${px} ${className}`}
        style={{ gridTemplateColumns: grid, ...style }}
        key="0"
      >
        {children}
      </li>
    );
  }
}

export { Banner };
